var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('Dialog',{attrs:{"visible":_vm.hasError,"title":_vm.errorTitle,"message":_vm.errorMessage,"show-cancel":false},on:{"ok":_vm.clearError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }